import { components } from 'react-select'
import { UatDataset } from '../../../../uat/types/uat-dataset.interface'
import { DropdownLibrarySingleValueProps } from './dropdown-library-single-value.props'

export const DropdownLibrarySingleValue =
  (uat?: UatDataset) => (props: DropdownLibrarySingleValueProps) => {
    return <components.SingleValue {...props} innerProps={{ ...uat } as any} />
  }
